/**
 * Adapter selection — once at boot from Zod-validated config (plan §1.1 rule 4).
 * No other module may branch on data source.
 */
import { createLocalRepository, type DatasetRepository } from '@meridian/core';

import type { AppConfig } from '@/config';

import { createHttpRepository } from './http-repository';

export function createRepository(config: AppConfig): DatasetRepository {
  if (config.dataSource === 'local') {
    /* Profile is non-null by AppConfig discrimination; parseConfig refuses
       production + local and never returns local without a profile. */
    return createLocalRepository({ profile: config.syntheticProfile });
  }
  return createHttpRepository({ baseUrl: config.apiBaseUrl });
}
